(() => {
  const ATTR = 'data-main-accordion-init';

  function bindAccordion(container) {
    if (container.hasAttribute(ATTR)) return;
    container.setAttribute(ATTR, '1');

    const detailsList = container.querySelectorAll('details');
    if (!detailsList.length) return;

    detailsList.forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        detailsList.forEach((other) => {
          if (other !== details && other.open) {
            other.open = false;
          }
        });
      });
    });
  }

  function init(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.main-accordion').forEach(bindAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
